import { Testimonial } from '../../types/testimonial';

export const bannerImage =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/ce56cc0be9b792c36fd0bbc1bb7010ca-1748509482183/04%20Banner%20image.png';

export const lovableIconImage =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/b57817980e4f8d590df1d62e1ade7854-1748513253909/Lovable.png';
export const base44IconImage =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/b57817980e4f8d590df1d62e1ade7854-1748513253898/Base44.png';
export const boltIconImage =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/b57817980e4f8d590df1d62e1ade7854-1748513253901/Bolt.png';
export const replitIconImage =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/b57817980e4f8d590df1d62e1ade7854-1748513253905/Replit.png';

export const testimonials: Testimonial[] = [
    {
        textKey: 'vibe_coding_perseus.testimonials.testimonial_1',
        author: 'Ivan Vega',
        authorRole: 'AI expert',
        link: 'https://www.fiverr.com/thesummary',
    },
    {
        textKey: 'vibe_coding_perseus.testimonials.testimonial_2',
        author: 'Alex J',
        authorRole: 'Full Stack Engineer',
        link: 'https://www.fiverr.com/alexjasonn',
    },
    {
        textKey: 'vibe_coding_perseus.testimonials.testimonial_3',
        author: 'Siraj S.',
        authorRole: 'Full Stack developer & AI expert',
        link: 'https://www.fiverr.com/sirajsiyabudeen',
    },
];

export const TITLE_SIZE = 'h_xxl';
export const TITLE_SIZE_MOBILE = 'h_xl';
export const INTERNAL_SERVER_ERROR_CODE = 500;
export const FREELANCER_PAGE_PATHFINDER_KEY = 'short_user';
export const STEPS_SECTION_ID = 'steps-section';
